module.exports = __webpack_public_path__ + "static/media/arrow-right.5d1a6726.svg";